import { get } from '@namespace/helpers';

export const getBsActiveBonus = () => get('/service/prewager/campaigns/active');
